import { UpdateFrequency } from '@kanbu/schema/enums';

export function getNextScheduledAt(updateFrequency: UpdateFrequency) {
  switch (updateFrequency) {
    case UpdateFrequency.Daily:
      return new Date(new Date().setDate(new Date().getDate() + 1));
    case UpdateFrequency.Weekly:
      return new Date(new Date().setDate(new Date().getDate() + 7));
    case UpdateFrequency.BiWeekly:
      return new Date(new Date().setDate(new Date().getDate() + 14));
    case UpdateFrequency.Monthly:
      return new Date(new Date().setMonth(new Date().getMonth() + 1));

    default:
      return null;
  }
}
